import { useRef } from "react";

import ComparePanelData from "./ComparePanelData";

export default function ComparePanel() {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={containerRef}
      className="relative w-full flex flex-col bg-white z-[998] h-full"
    >
      <div
        className="flex flex-row gap-2 w-full py-2 h-full"
        data-testid="compare-panel"
      >
        <ComparePanelData />
      </div>
    </div>
  );
}
